import React from "react";
import AppLayoutContext, { AppLayoutContextValue } from "contexts/AppLayoutContext";

type Props = {
  children: React.ReactNode;
};

const AppLayoutProvider: React.FC<Props> = ({ children }) => {
  const [isSideNavigationCollapsed, setIsSideNavigationCollapsed] = React.useState<boolean>(true);
  const [isDetailsPanelCollapsed, setIsDetailsPanelCollapsed] = React.useState<boolean>(true);

  const value = React.useMemo<AppLayoutContextValue>(
    () => ({
      isSideNavigationCollapsed,
      isDetailsPanelCollapsed,
      setSideNavigationCollapsed: setIsSideNavigationCollapsed,
      setDetailsPanelCollapsed: setIsDetailsPanelCollapsed,
    }),
    [isSideNavigationCollapsed, isDetailsPanelCollapsed],
  );

  return <AppLayoutContext.Provider value={value}>{children}</AppLayoutContext.Provider>;
};

export default AppLayoutProvider;
